import { OidcProviderData } from "@istari/istari-client";

import { OidcProviderConfig } from "../../model/oidc-provider-config";

// Assign by name onto the instance: positional ctor args would misroute on an SDK regen reorder,
// and an untyped Object.assign would silently drop a renamed field.
export function toOidcProviderData(config: OidcProviderConfig): OidcProviderData {
  const data = new OidcProviderData(config.issuer, config.clientId);
  data.scopes = config.scopes;
  data.usePkce = config.usePkce;
  data.authorizationEndpoint = config.authorizationEndpoint;
  data.tokenEndpoint = config.tokenEndpoint;
  data.clientSecretHeader = config.clientSecretHeader;
  data.sendScopeOnRefresh = config.sendScopeOnRefresh;
  data.sendRedirectUriOnRefresh = config.sendRedirectUriOnRefresh;
  data.tlsCaPem = config.tlsCaPem;
  data.tlsVerify = config.tlsVerify;
  return data;
}
